import { Observable } from "rxjs"
import { ObservableFromFetch } from "../ObservableFromFetch"
import RandomSelectionRunData from "./RandomsModel/RandomSelectionRunData"

interface RandomSelectionRunOptions {
  ContactId: number
  UpdateMethodID: number
  PoolId: number
  RequiredDrug: number
  RequiredAlcohol: number
  AlternateDrug: number
  AlternateAlcohol: number
}

export interface RunCancelPoolsMessages {
  PoolName: string
  PoolCode: string
  Message: string
}

export interface PoolRunData {
  PoolID: number
  PoolName: string
  PoolCode: string
  IsConsortium: boolean
}

export default function RandomSelectionRunObservable(options: RandomSelectionRunOptions): Observable<RandomSelectionRunData[]> {
  const params: string = JSON.stringify(options)
  return ObservableFromFetch<RandomSelectionRunData[]>("WorkforceRandomTest/RunRandomSelection", params)
}

export function RunCancelPoolsObservable(cancel: boolean, selectedPools: PoolRunData[]) {
  const params: string = JSON.stringify({
    Cancel: cancel,
    SelectedPools: selectedPools
  })
  return ObservableFromFetch<RunCancelPoolsMessages[]>("WorkforceRandomTest/RunCancelSelectedPools", params)
}
